<template>
    <div id="app">
        <router-view v-if="isRouterAlive"></router-view>
    </div>
</template>

<script>
import V_SHARE from './tz';

export default {
    name: 'app',
    provide() {
        return {
            reload: this.reload,
        }
    },
    data() {
        return {
            isActive: false,
            isRouterAlive: true,
        }
    },
    mounted() {
        // this.$router.replace('/waiting');
        document.title = this.$t('title');
    },
    created() {
        V_SHARE();
    },
    methods: {
        changeLang(e) {
            let lang = e.target.dataset.lang;
            this.$i18n.locale = lang;
            this.isActive = lang == "zh" ? true : false;
        },
        reload() {
            this.isRouterAlive = false
            this.$nextTick(function () {
                this.isRouterAlive = true
            })
        },
    }
}
</script>

<style>
@import "assets/css/common.css";
@import "assets/css/theme.css";
@import "assets/css/layer.css";
@import "assets/css/notification.css";

#app {
    width: 100%;
    height: 100%;
    overflow-y: auto;
}

.container {
    min-height: 100%;
    background: url(https://oss.eventnet.cn/H5/Nissan_meeting/2024/bg.jpg?v=12190955) no-repeat;
    background-size: 100% 100%;
    background-position: center bottom;
}

.pswp__img {
    pointer-events: none !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue